import React from "react";
import { Button } from "@mui/material";

export default function CartOrDashboardButton({ user }) {
  return (
    <Button
     sx={{
        // borderRadius: "50px",
        height: "60px",
      }}
      href={user ? "/dashboard" : "/order"}
      variant="primaryButton"
    >
      {user ? "Panel" : "Zobacz Menu"}
    </Button>
  );
}